import { createContext } from 'react';

export const STEP_STATE = {
  AUTO: 'AUTO',
  MANUAL: 'MANUAL',
};

export const WizardPerfMarkerContext = createContext({});
